// Which VAT mode the edit form opens a document in.
//
// "auto" recomputes VAT = taxable × the restaurant rate the moment the form
// opens. For a supplier with no VAT rule that silently overwrote the VAT the
// document carries: a produce note stored at 0 VAT (server/lib/noteVat.js), or
// a produce invoice saved with 0, came back as 18% on the first "אשר ושמור" —
// and on a note that 18% then became the supplier's VAT "history".
// So a document opens in "manual" — keeping the stored VAT — whenever it is
// not what auto would compute anyway, or a note is flagged for a VAT check.
// The user can still click "אוטו". Every document type, since 22/10/2026
// (owner, #314): credit invoices, receipts and חשבון עסקה used to open in auto
// and silently replace their printed VAT with the rate. The review screen's
// totals check now shows the calculated VAT beside a printed one that differs,
// with one tap to apply it — never by itself.
import { round2 } from './money';

export function initialVatMode(doc, vatRate) {
  if (!doc) return 'auto';
  if (doc.vat_needs_check) return 'manual';
  const subtotal = parseFloat(doc.subtotal) || 0;
  const discount = parseFloat(doc.invoice_discount) || 0;
  const discAmt = doc.invoice_discount_type === 'amount' ? discount : subtotal * discount / 100;
  const autoVat = round2((subtotal - discAmt) * (parseFloat(vatRate) || 0) / 100);
  return Math.abs((parseFloat(doc.vat) || 0) - autoVat) > 0.01 ? 'manual' : 'auto';
}
